import CanBoNhanKetQuaKiemTraDeXuatPage from './CanBoNhanKetQuaKiemTraDeXuatPage.jsx';
import KetQuaCanBoNhanKetQuaKiemTraDeXuatPage from './KetQuaCanBoNhanKetQuaKiemTraDeXuatPage.jsx';
export {
  CanBoNhanKetQuaKiemTraDeXuatPage,
  KetQuaCanBoNhanKetQuaKiemTraDeXuatPage
};



// WEBPACK FOOTER //
// ./src/components/pages/reception/index.js